import { vMaska } from 'maska/vue'

export default defineNuxtPlugin((nuxtApp) => {
    // Note: v-mask is Vue 2 only. Using maska for Vue 3
    // Install: npm install maska
    nuxtApp.vueApp.directive('mask', vMaska)
})
